import { createProgram, createShader, glsl } from '../utils';
import { vertexShaderSource } from './vertexShader';

export const temporalBlendFragmentShader = glsl`#version 300 es
precision highp float;

in vec2 texCoords;

uniform sampler2D u_current;
uniform sampler2D u_previous;
uniform float u_blendFactor;

out vec4 fragColor;

void main() {
    float current  = texture(u_current,  texCoords).r;
    float previous = texture(u_previous, texCoords).r;
    fragColor = vec4(vec3(mix(previous, current, u_blendFactor)), 1.0);
}
`;

export function createTemporalBlendProgram(gl: WebGL2RenderingContext) {
    const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource(false));
    const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, temporalBlendFragmentShader);
    const program = createProgram(gl, vertexShader, fragmentShader);

    const uniforms = {
        position: gl.getAttribLocation(program, 'position'),
        current: gl.getUniformLocation(program, 'u_current'),
        previous: gl.getUniformLocation(program, 'u_previous'),
        blendFactor: gl.getUniformLocation(program, 'u_blendFactor'),
    };

    return { program, uniforms };
}
